export default __webpack_public_path__ + "static/media/options.df86c162.svg";